import MenuList from '@/pages/components/manage/sys/menu/MenuList';

export default {
    list: MenuList,
    recordRepresentation: 'menuName',
};